export var OccSeatingLegendItemType;
(function (OccSeatingLegendItemType) {
    OccSeatingLegendItemType["Normal"] = "Normal";
    OccSeatingLegendItemType["Wheelchair"] = "Wheelchair";
    OccSeatingLegendItemType["Companion"] = "Companion";
    OccSeatingLegendItemType["Sofa"] = "Sofa";
    OccSeatingLegendItemType["Friend"] = "Friend";
})(OccSeatingLegendItemType || (OccSeatingLegendItemType = {}));
//# sourceMappingURL=legend-item-type.js.map